import { render, staticRenderFns } from "./RightBlockInfo.vue?vue&type=template&id=f347cc6a&"
import script from "@/scripts/promotions/rightBlockInfo.js?vue&type=script&lang=js&"
export * from "@/scripts/promotions/rightBlockInfo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports